/*! Copyright 2025 Fonticons, Inc. - https://webawesome.com/license */

// _bundle_/src/styles/component/size.styles.ts
import { css } from "lit";
var size_styles_default = css`
  :host([size='small']),
  .wa-size-s {
    font-size: var(--wa-font-size-s);
  }

  :host([size='medium']),
  .wa-size-m {
    font-size: var(--wa-font-size-m);
  }

  :host([size='large']),
  .wa-size-l {
    font-size: var(--wa-font-size-l);
  }
`;

export {
  size_styles_default
};
